import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438",
  code: "bg",
  messages: {
    alert: {
      close: "\u0417\u0430\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    },
    authForm: {
      hidePassword: "\u0421\u043A\u0440\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u0430\u0442\u0430",
      showPassword: "\u041F\u043E\u043A\u0430\u0436\u0438 \u043F\u0430\u0440\u043E\u043B\u0430\u0442\u0430",
      submit: "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0438"
    },
    banner: {
      close: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"
    },
    calendar: {
      nextMonth: "\u0421\u043B\u0435\u0434\u0432\u0430\u0449 \u043C\u0435\u0441\u0435\u0446",
      nextYear: "\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u0430 \u0433\u043E\u0434\u0438\u043D\u0430",
      prevMonth: "\u041F\u0440\u0435\u0434\u0438\u0448\u0435\u043D \u043C\u0435\u0441\u0435\u0446",
      prevYear: "\u041F\u0440\u0435\u0434\u0438\u0448\u043D\u0430 \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    carousel: {
      dots: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0441\u043B\u0430\u0439\u0434 \u0437\u0430 \u043F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0435",
      goto: "\u041E\u0442\u0438\u0434\u0435\u0442\u0435 \u043D\u0430 \u0441\u043B\u0430\u0439\u0434 {slide}",
      next: "\u041D\u0430\u043F\u0440\u0435\u0434",
      prev: "\u041D\u0430\u0437\u0430\u0434"
    },
    chatPrompt: {
      placeholder: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0441\u044A\u043E\u0431\u0449\u0435\u043D\u0438\u0435..."
    },
    chatPromptSubmit: {
      label: "\u0418\u0437\u043F\u0440\u0430\u0442\u0438"
    },
    colorMode: {
      dark: "\u0422\u044A\u043C\u043D\u043E",
      light: "\u0421\u0432\u0435\u0442\u043B\u043E",
      switchToDark: "\u041F\u0440\u0435\u0432\u043A\u043B\u044E\u0447\u0438 \u043A\u044A\u043C \u0442\u044A\u043C\u0435\u043D \u0440\u0435\u0436\u0438\u043C",
      switchToLight: "\u041F\u0440\u0435\u0432\u043A\u043B\u044E\u0447\u0438 \u043A\u044A\u043C \u0441\u0432\u0435\u0442\u044A\u043B \u0440\u0435\u0436\u0438\u043C",
      system: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430"
    },
    commandPalette: {
      back: "\u041D\u0430\u0437\u0430\u0434",
      close: "\u0417\u0430\u0442\u0432\u043E\u0440\u0435\u0442\u0435",
      noData: "\u041D\u044F\u043C\u0430 \u0434\u0430\u043D\u043D\u0438",
      noMatch: "\u041D\u044F\u043C\u0430 \u0441\u044A\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0435 \u043D\u0430 \u0434\u0430\u043D\u043D\u0438",
      placeholder: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u0438\u043B\u0438 \u043F\u043E\u0442\u044A\u0440\u0441\u0435\u0442\u0435..."
    },
    contentSearch: {
      links: "\u0412\u0440\u044A\u0437\u043A\u0438",
      theme: "\u0422\u0435\u043C\u0430"
    },
    contentSearchButton: {
      label: "\u0422\u044A\u0440\u0441\u0435\u043D\u0435"
    },
    contentToc: {
      title: "\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435"
    },
    dashboardSearch: {
      theme: "\u0422\u0435\u043C\u0430"
    },
    dashboardSearchButton: {
      label: "\u0422\u044A\u0440\u0441\u0435\u043D\u0435"
    },
    dashboardSidebarCollapse: {
      collapse: "\u0421\u0432\u0438\u0439",
      expand: "\u0420\u0430\u0437\u0448\u0438\u0440\u0438"
    },
    dashboardSidebarToggle: {
      close: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438",
      open: "\u041E\u0442\u0432\u043E\u0440\u0438"
    },
    error: {
      clear: "\u0418\u0437\u0447\u0438\u0441\u0442\u0438"
    },
    fileUpload: {
      removeFile: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438 {filename}"
    },
    header: {
      close: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438",
      open: "\u041E\u0442\u0432\u043E\u0440\u0438"
    },
    inputMenu: {
      create: '\u0421\u044A\u0437\u0434\u0430\u0439\u0442\u0435 "{label}"',
      noData: "\u041D\u044F\u043C\u0430 \u0434\u0430\u043D\u043D\u0438",
      noMatch: "\u041D\u044F\u043C\u0430 \u0441\u044A\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0435 \u043D\u0430 \u0434\u0430\u043D\u043D\u0438"
    },
    inputNumber: {
      decrement: "\u041D\u0430\u043C\u0430\u043B\u044F\u0432\u0430\u043D\u0435",
      increment: "\u0423\u0432\u0435\u043B\u0438\u0447\u0430\u0432\u0430\u043D\u0435"
    },
    modal: {
      close: "\u0417\u0430\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    },
    pricingTable: {
      caption: "\u0426\u0435\u043D\u043E\u0432\u0430 \u0442\u0430\u0431\u043B\u0438\u0446\u0430"
    },
    prose: {
      codeCollapse: {
        closeText: "\u0421\u0433\u044A\u043D\u0438",
        name: "\u043A\u043E\u0434",
        openText: "\u0420\u0430\u0437\u0433\u044A\u043D\u0438"
      },
      collapsible: {
        closeText: "\u0421\u043A\u0440\u0438\u0439",
        name: "\u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430",
        openText: "\u041F\u043E\u043A\u0430\u0436\u0438"
      },
      pre: {
        copy: "\u041A\u043E\u043F\u0438\u0440\u0430\u0439 \u043A\u043E\u0434\u0430 \u0432 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434\u0430"
      }
    },
    selectMenu: {
      create: '\u0421\u044A\u0437\u0434\u0430\u0439\u0442\u0435 "{label}"',
      noData: "\u041D\u044F\u043C\u0430 \u0434\u0430\u043D\u043D\u0438",
      noMatch: "\u041D\u044F\u043C\u0430 \u0441\u044A\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0435 \u043D\u0430 \u0434\u0430\u043D\u043D\u0438",
      search: "\u041F\u043E\u0442\u044A\u0440\u0441\u0435\u0442\u0435..."
    },
    slideover: {
      close: "\u0417\u0430\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    },
    table: {
      noData: "\u041D\u044F\u043C\u0430 \u0434\u0430\u043D\u043D\u0438"
    },
    toast: {
      close: "\u0417\u0430\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    }
  }
});
